import React, { useState } from 'react';
import { number, func } from 'prop-types';
import { noop } from 'lodash';
import { Icon } from '@fiverr-private/fit';
import { r_volume_high, r_volume_low, r_volume_off } from '@fiverr-private/icons';
import './volumeBar.scss';

const VolumeBar = ({ volume = 0, handleVolumeChange = noop }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [previousVolume, setPreviousVolume] = useState(volume);

    const openBar = () => {
        setIsOpen(true);
    };

    const closeBar = () => {
        setIsOpen(false);
    };

    const handleChange = (e) => {
        const newVolume = parseFloat(e?.target.value);
        setPreviousVolume(newVolume);
        handleVolumeChange(newVolume);
    };

    const handleMute = () => {
        if (volume !== 0) {
            handleVolumeChange(0);
        } else {
            handleVolumeChange(previousVolume);
        }
    };

    const generateVolumeIcon = () => {
        let icon;

        if (volume === 0) {
            icon = r_volume_off;
        } else if (volume <= 0.5) {
            icon = r_volume_low;
        } else {
            icon = r_volume_high;
        }

        return icon;
    };

    return (
        <div className="volume-bar" onMouseOver={openBar} onMouseLeave={closeBar}>
            <Icon className="volume-button" size={20} onClick={handleMute}>
                {generateVolumeIcon()}
            </Icon>
            {isOpen && (
                <input
                    id="vol-control"
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    style={{ '--min': 0, '--max': 1, '--val': volume }}
                    value={volume}
                    onChange={handleChange}
                />
            )}
        </div>
    );
};

VolumeBar.propTypes = {
    volume: number,
    handleVolumeChange: func,
};

export default VolumeBar;
